<template>
    <div class="add-action-modal-wrapper">
        <TitleBaseBox :title="data.title" :noButton="true" @close="close" class="add-action-box">
            <div class="action-title">
                <div class="action-title-label">
                    <label class="action-title-level1">动作名称</label>
                    <el-input class="action-title-input" v-model="actionName" placeholder="请输入" @input="checkName" />
                    <div v-show="!isNameValid" class="el-form-item__error">
                        {{ errMsg }}
                    </div>
                </div>
            </div>
            <div class="action-logic">
                <label class="action-title-level1">动作逻辑</label>
                <div class="action-logic-right">
                    <div class="action-logic-tip-title">
                        <span v-show="actionIsEmpty" class="type">请选择一个动作类型</span>
                        <span v-show="!actionIsEmpty" class="then">THEN</span>
                        <span class="use-guide"><i class="el-icon-s-management" /> 使用指南</span>
                    </div>
                    <div class="action-logic-some-type" v-if="actionIsEmpty">
                        <span v-for="action in actions" :key="action.value" @click="choseType(action)">
                            <i :class="action.iconCls" />
                            {{ action.label }}
                        </span>
                    </div>
                    <component :is="actionType" :value="actionContent" @change="actionContentChange" ref="actionComp" />
                    <span class="op" v-show="!actionIsEmpty">
                        <i class="delete" @click="emptyAction"></i>
                    </span>
                </div>
            </div>
            <div class="add-action-bottom">
                <RoundButton :text="cancelLabel" cls="cancel-btn" @btnClick="cancelClick" />
                <RoundButton :text="confirmLabel" @btnClick="confirmClick" />
            </div>
        </TitleBaseBox>
    </div>
</template>
<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import SendAction from "./SendAction";
import IssueAction from "./IssueAction";
import { getRpaActionNodeDetail, updateRpaActionNode } from "../../service";
import { stringRequired, stringRegExp } from "@/views/zhiji/components/commonForm/rules.js";

const actions = [
    {
        label: "发送消息",
        value: "SendAction",
        iconCls: "sending-icon"
    },
    {
        label: "关闭issue",
        value: "IssueAction",
        iconCls: "end-icon"
    }
];

export default {
    name: "ActionEditModal",
    props: ["data"],
    components: {
        TitleBaseBox,
        RoundButton,
        SendAction,
        IssueAction,
    },
    data() {
        return {
            actionName: "",
            actionId: "",
            isClickAction: false, // 是否选择了类型
            isNameValid: true,
            isCompValid: true,
            actionType: "",
            actions,
            actionContent: null,
            isInit: false,
            errMsg: "",
        };
    },
    computed: {
        confirmLabel() {
            return this.$t("zhiji.common.confirm");
        },
        cancelLabel() {
            return this.$t("zhiji.common.cancel");
        },
        actionIsEmpty() {
            return !this.actionType;
        },
    },
    async created() {
        const detail = await getRpaActionNodeDetail(this.data);
        this.actionName = detail.actionName;
        this.actionId = detail.actionId;
        this.actionType = detail.actionType;
        this.actionContent = detail.actionContent;
    },
    methods: {
        choseType(action) {
            this.actionType = action.value;
        },
        actionContentChange(content) {
            this.actionContent = content;
        },
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            this.close();
        },
        async confirmClick() {
            await this.validate();
            if (!this.isNameValid || !this.isCompValid) {
                return;
            }
            const data = {
                rpaId: this.data.rpaId,
                nodeId: this.data.nodeId,
                nodeType: this.data.nodeType,
                actionName: this.actionName,
                actionId: this.actionId,
                actionType: this.actionType,
                actionContent: this.actionContent,
            };
            await updateRpaActionNode(data);
            this.data.submit && this.data.submit();
            this.cancelClick();
        },
        emptyAction() {
            this.actionType = "";
            this.actionContent = [];
        },
        checkName() {
            if (!(this.isNameValid = stringRequired(this.actionName))) {
                this.errMsg = "请输入名称";
            } else if (!(this.isNameValid = stringRegExp(this.actionName, {regExp:/<|>/}))) {
                this.errMsg = "名称不可携带<>,会有xss安全风险";
            }
        },
        async checkComp() {
            this.isCompValid = await this.$refs.actionComp.validate();
        },
        async validate() {
            this.checkName();
            await this.checkComp();
        }
    },
};
</script>
<style scoped lang="less">
@import (reference) url("../common/rpaNode.less");
@contentWidth: 730px;

.action-title-level1 {
    display: inline-block;
    width: 80px;
}
.action-title-input {
    width: calc(100% - 80px);
}
.add-action-modal-wrapper {
    .modal-wrapper();
    /deep/.title-base-mask .base-content {
        padding: 20px 20px 10px 20px;
        max-height: none;
    }
    .add-action-box {
        width: 900px;
        max-height: 90%;
        .action-title {
            .action-title-label {
                position: relative;
            }
        }
    }
    .action-logic {
        display: flex;
        margin-top: 20px;
        .action-logic-right {
            margin-bottom: 86px;
            .action-logic-tip-title {
                display: flex;
                justify-content: space-between;
                width: @contentWidth;
                .type {
                    font-size: 14px;
                }
                .then {
                    font-weight: bold;
                    font-size: 16px;
                    color: #3f4760;
                }
                .use-guide {
                    color: #2ec2ff;
                    i {
                        color: #2ec2ff;
                    }
                }
            }
            .action-logic-some-type {
                display: flex;
                margin-top: 8px;
                font-size: 14px;
                span {
                    border: 1px solid #d8e4f0;
                    border-radius: 4px;
                    padding: 10px 18px;
                    margin-right: 10px;
                    cursor: pointer;
                    i {
                        display: inline-block;
                        height: 29px;
                        vertical-align: -7px;
                        margin-right: 5px;
                    }
                }
                .sending-icon {
                    width: 42px;
                    background: url("@{zhijiStaticImagePath}send-message-icon.png");
                }
                .end-icon {
                    width: 43px;
                    background: url("@{zhijiStaticImagePath}close-issue-icon.png");
                }
            }
        }
    }
}

.add-action-bottom {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    box-shadow: 0 -0.5px 0 0 #dde8f3;
    border-radius: 0 0 4px 4px;
    background: #fafbfd;
    padding-top: 20px;
    margin-top: 20px;
    height: 50px;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
}

.op {
    .span-op();
    position: absolute;
    right: 36px;
    top: 135px;
}
.delete {
    width: 16px;
    height: 18px;
    background: url(/zhiji/images/class-spr.png);
    background-position: -96px 0;

    &:hover {
        background-position: -96px -22px;
    }
}
.el-form-item__error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 9%;
}
</style>
